import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { DirectionType, HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';


const stepsList = [
  { text: "1", active: false, completed: false, tooltip: '', listHelp: ['777'] },
  { text: "2", active: true, completed: false, tooltip: ' ', listHelp: ['779'] }
];

const tableStructure = [
  { id: 'tipoRentaNombre', title: 'Tipo de renta gravable' },
  { id: 'valItem', title: 'Valor' }
];

class Form1 {
  id: number;
  tipoRenta: string;
  tipoRentaNombre: string;
  valItem: string;
  deshabilitarAcci: boolean;
}
@Component({
  selector: 'app-rentas-liquidas-gravables-modal',
  templateUrl: './rentas-liquidas-gravables-modal.component.html',
  styleUrls: ['./rentas-liquidas-gravables-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentasLiquidasGravablesComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listTipoRentaLiquidaGravable: DValorDominio[] = [];
  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  mensajeTabla = "¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave: boolean;

  constructor(
    public dialogRef: MatDialogRef<RentasLiquidasGravablesComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.listTipoRentaLiquidaGravable = this.listTipoRentaLiquidaGravable.filter(item => item.valor == "3");
  }

  protected controlStep(direction: DirectionType): void { }

  validateDataPatrimonio() {
    if (!this.model.doc.cuerpo.cc_id_783)
      this.model.doc.cuerpo.cc_id_783 = [];

    const cc166 = this.model.doc.cuerpo.cs_id_166;// = [{it: 1, v: '9554264'}];
    const cc172 = this.model.doc.cuerpo.cs_id_172;// = [{it: 1, v: '9554264'}];

    if (cc166) {// && Array.isArray(cc166) && cc166.length
      //const containValue166 = cc166.filter(item => Number(item.v) > 0);
      //if (containValue166.length) {
      //const value = Math.max(...containValue166.map(item => Number(item.v))).toString();
      const valueFormated = this.dutilidades.obtenerFormatoMoneda(cc166);//value
      this.modelForm.tipoRenta = "1"
      this.model.doc.cuerpo.cc_id_779.push({ it: 1, v: '1' });
      if (this.listTipoRentaLiquidaGravable.find(item => item.valor == '1')) {
        this.modelForm.tipoRentaNombre = this.listTipoRentaLiquidaGravable.find(item => item.valor == '1').nombre;
      }
      this.modelForm.valItem = valueFormated;
      this.modelForm.deshabilitarAcci = true;

      const indexExistValue = this.model.doc.cuerpo.cc_id_779.findIndex(item => item.v == '1');
      if (indexExistValue > -1 && this.model.doc.cuerpo.cc_id_780[indexExistValue])
        this.model.doc.cuerpo.cc_id_780[indexExistValue].v = valueFormated;
      else {
        this.model.doc.cuerpo.cc_id_780.push({ it: 1, v: valueFormated });
        this.model.doc.cuerpo.cc_id_783.push({ it: 1, v: 'P8' });
        this.dataSourceBody.push(this.modelForm);
      }

      this.inicializeForm();
      //}
    }

    if (cc172) {// && Array.isArray(cc172) && cc172.length
      //const containValue172 = cc172.filter(item => Number(item.v) > 0);
      //if (containValue172.length) {
      //const value = Math.max(...containValue172.map(item => Number(item.v))).toString();
      const valueFormated = this.dutilidades.obtenerFormatoMoneda(cc172); //value
      this.modelForm.tipoRenta = "2";
      this.model.doc.cuerpo.cc_id_779.push({ it: 1, v: '2' });      
      const item = this.listTipoRentaLiquidaGravable.find(item => item.valor == '2');
      if (item) this.modelForm.tipoRentaNombre = item.nombre;
      this.modelForm.valItem = valueFormated;
      this.modelForm.deshabilitarAcci = true;

      const indexExistValue = this.model.doc.cuerpo.cc_id_779.findIndex(item => item.v == '2');
      if (indexExistValue > -1 && this.model.doc.cuerpo.cc_id_780[indexExistValue])
        this.model.doc.cuerpo.cc_id_780[indexExistValue].v = valueFormated;
      else {
        this.model.doc.cuerpo.cc_id_780.push({ it: 1, v: valueFormated });
        this.model.doc.cuerpo.cc_id_783.push({ it: 1, v: 'P11' });
        this.dataSourceBody.push(this.modelForm);
      }

      this.inicializeForm();
      //}
    }

    this.operacionCs781();
    this.inicializeForm();
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.tipoRenta = "0";
    this.modelForm.tipoRentaNombre = "";
    this.modelForm.valItem = "0";
    this.modelForm.deshabilitarAcci = false;
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_779 == undefined) {
      this.model.doc.cuerpo.cc_id_779 = [];
      this.model.doc.cuerpo.cc_id_780 = [];
      this.model.doc.cuerpo.cc_id_783 = [];
    }
  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_779.length; i++) {
      if (this.model.doc.cuerpo.cc_id_779[i] && this.model.doc.cuerpo.cc_id_780[i]) {
        this.modelForm.id = i;
        this.modelForm.tipoRenta = this.model.doc.cuerpo.cc_id_779[i].v;
        if (this.listTipoRentaLiquidaGravable && this.listTipoRentaLiquidaGravable.length > 0 && this.listTipoRentaLiquidaGravable[this.model.doc.cuerpo.cc_id_779[i].v - 1])
          this.modelForm.tipoRentaNombre = this.listTipoRentaLiquidaGravable[this.model.doc.cuerpo.cc_id_779[i].v - 1].nombre;
        this.modelForm.valItem = this.model.doc.cuerpo.cc_id_780[i].v;
        this.modelForm.deshabilitarAcci = this.modelForm.tipoRenta == '1' || this.modelForm.tipoRenta == '2';
        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
      }
    }
    this.validateDataPatrimonio();
    this.operacionCs781();
  }

  public editModeloDesdeForm() {
    if (
      this.model.doc.cuerpo.cc_id_779[this.modelForm.id] &&
      this.model.doc.cuerpo.cc_id_780[this.modelForm.id]
    ) {
      this.model.doc.cuerpo.cc_id_779[this.modelForm.id].v = this.modelForm.tipoRenta;
      this.model.doc.cuerpo.cc_id_780[this.modelForm.id].v = this.modelForm.valItem.toString();
      this.model.doc.cuerpo.cc_id_783[this.modelForm.id].v = 'R3';
    }
  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_779.push({ it: i, v: this.modelForm.tipoRenta });
    this.model.doc.cuerpo.cc_id_780.push({ it: i, v: this.modelForm.valItem });
    this.model.doc.cuerpo.cc_id_783.push({ it: i, v: 'R3' });
  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_779.splice(index, 1);
    this.model.doc.cuerpo.cc_id_780.splice(index, 1);
    this.model.doc.cuerpo.cc_id_783.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_779.length; i++) {
      this.model.doc.cuerpo.cc_id_779[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_780[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_783[i].it = i + 1;
    }
  }

  public validateFormCompleted(): boolean {
    return !this.modelForm.tipoRenta || !this.modelForm.valItem;
  }

  public redondearFormData() {
    this.modelForm.valItem = this.dutilidades.redondearValorMoneda(this.modelForm.valItem.toString(), true);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        //this.editModeloDesdeForm();
        this.modelForm.tipoRentaNombre = this.listTipoRentaLiquidaGravable.find(item => item.valor == this.modelForm.tipoRenta).nombre;
        this.modelForm.deshabilitarAcci = false;
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) {
        const existElement = this.dataSourceBody.find(item => item.tipoRenta == this.modelForm.tipoRenta);

        if (existElement) {
          this.dNotificacionServicio.mostrarDialogoInformacion("Ya existe un registro con el mismo concepto, por favor revise e intente nuevamente");
          return;
        }

        const indexExistValue = this.model.doc.cuerpo.cc_id_779.findIndex(item => item.v == '3');
        if (indexExistValue > -1) {
          this.model.doc.cuerpo.cc_id_780[indexExistValue].v = this.modelForm.valItem;
        } else {
          this.model.doc.cuerpo.cc_id_779.push({ it: 1, v: '3' });
          this.model.doc.cuerpo.cc_id_780.push({ it: 1, v: this.modelForm.valItem });
          this.model.doc.cuerpo.cc_id_783.push({ it: 1, v: 'R3' });
        }

        this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.tipoRenta = "3";
        this.modelForm.tipoRentaNombre = this.listTipoRentaLiquidaGravable.find(item => item.valor == this.modelForm.tipoRenta).nombre;
        this.modelForm.deshabilitarAcci = false;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }

      //Recalcular y reinicializar
      this.operacionCs781();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs781();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }

  operacionCs781() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valItem, suma);
    }
    this.model.doc.cuerpo.cs_id_781 = suma;
  }

  closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs781();
    this.dialogRef.close("");
  }

  guardar() {
    this.model.doc.cuerpo.cc_id_779 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.saveModel.emit(true);
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component.ts